import { render, staticRenderFns } from "./CoreChoicesComponent.vue?vue&type=template&id=4b04f5f7&scoped=true"
import script from "./CoreChoicesComponent.vue?vue&type=script&lang=js"
export * from "./CoreChoicesComponent.vue?vue&type=script&lang=js"
import style0 from "./CoreChoicesComponent.vue?vue&type=style&index=0&id=4b04f5f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b04f5f7",
  null
  
)

export default component.exports